export const successColor = '#7CC522FF';
export const dangerColor = '#ff4d4d';

export const primaryColor = '#00DDFF';
export const secondaryColor = '#ee8b4f';

export const textColor = '#181A30';

export const defaultBorderColor = '#d2d2d2';

export const defaultBorderRadius = '4px';

const defaultTheme = {
  fontFamily: {
    main: 'Effra, sans-serif',
    code: 'Monaco, monospace',
  },
  fontSize: {
    h1: '2.57rem',
    h2: '2rem',
    h3: '18px',
    h5: '0.92rem',
    larger: '1.2rem',
    default: '1rem',
    smaller: '0.93rem',
    xsmall: '0.53rem',
  },
  spacing: {
    small: '0.5rem',
    default: '0.8rem',
    medium: '1.25rem',
    large: '1.9rem',
    xLarge: '3rem',
  },
  radius: {
    xSmall: '0.30rem',
    small: '0.57rem',
    normal: '1rem',
    default: '1rem',
  },
  size: {
    medium: '2.5rem',
    large: '104px',
    small: '24px',
  },
  link: {
    color: '#454b49',
  },
  defaultBorderRadius: defaultBorderRadius,
  pageHeader: {
    height: '64px',
    color: '#454b49',
    backgroundColor: '#fff',
    borderBottom: '1px solid #333',
    logo: {
      height: '64px',
    },
    branding: {
      text: {
        fontSize: '24px',
        color: '#454b49',
      },
    },
    separator: {
      color: '#000',
      height: '32px',
    },
    nav: {
      color: '#454b49',
      hoverColor: '#257789',
    },
  },
  sectionHeader: {
    color: '#454b49',
  },
  padding: {
    small: '1rem 0.5rem',
  },
  palette: {
    // legacy styles - left only for some shared components
    white: '#ffffff',
    textColor: textColor,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    pdfIconColor: 'rgb(213,80,80)',
    folderIconColor: 'rgb(101, 101, 101)',
    defaultIconColor: 'rgb(91, 127, 245)',
    pptxIconColor: '#D04423',
    error: '#fe615a',
    errorDimmed: '#ffb3b0',
    grey: '#ececec',
    darkGrey: '#8d8d8d',
    linkHoverColor: '#215EFFFF',
    linkColor: '#454b49',
    textLinkColor: '#215EFFFF',
    warning: '#F44336',
    danger: dangerColor,
    success: successColor,
    // hoverBackgroundColor: '#25778917',
    hoverBackgroundColor: 'rgba(227, 227, 227, 0.87)',
    selectedBackgroundColor: 'lightskyblue',
    buttonTextColor: '#262626',
    // new styles
    gray: '#72748A',
    grayLighter: '#9799A6',
    black: 'black',
    text: textColor,
    textDimmed: '#757575',
    border: '#A4D6EC',
    stroke: '#E8ECEF',
    accent: '#A5F3FF',
    accentText: '#181A30',
    placeholderText: '#72748A',
    background: '#B4E6FC',
    iconButtonHoverBackground: '#f2f2f4',
  },
  groups: {
    libraryGroupBackgroundColor: 'rgb(238, 247, 249)',
    sortGroupBackgroundColor: 'rgb(218, 246, 252)',
    libraryGroupBorder: '2px solid rgb(65, 171, 193)',
    sortGroupBorder: '2px solid white',
    sortListGroupBorder: '2px solid rgb(65, 171, 193)',
  },
  slideStatusInfo: {
    newBackgroundColor: '#7cc522',
    newTextColor: '#ffffff',
    updatedBackgroundColor: '#0080ff',
    updatedTextColor: '#ffffff',
  },
  sortTabSideTabsContent: {
    rowGap: '5px',
    padding: '10px 20px 10px 20px',
    height: '580px',
  },
  slideSortThumbnail: {
    fontSize: '12px',
    color: 'rgba(33, 94, 255, 0.8)',
    backgroundColor: '#fff',
    hoverShadow: 'rgb(0 0 0 / 14%) 4px 8px 20px 0px',
    addedBackgroundColor: 'rgba(124, 197, 34, 0.2)',
    slideOverBarColor: 'blue',
    slideOverBarWidth: '2px',
    activeBorder: '4px solid rgb(95,143,192)',
    deleteButton: {
      backgroundColor: '#fff',
      color: '#8d8d8d',
      hoverColor: '#ff4d4d',
      disabledColor: '#ececec',
    },
  },
  slideDividerThumbnail: {
    backgroundColor: '#fff',
    color: 'rgba(33, 94, 255, 0.8)',
    fontSize: '14px',
    border: '3px dashed rgba(151, 151, 151, 0.59)',
    borderRadius: '4px',
    draggingOpacity: '0.7',
  },
  slideListItem: {
    fontSize: '12px',
    indexFontSize: '12px',
    fontWeight: 'bold',
    padding: '10px 10px',
    slideOverBarColor: 'blue',
    slideOverBarWidth: '2px',
    draggingOpacity: '0.9',
    backgroundColor: 'rgb(238,247,249)',
    containerBackgroundColor: 'white',
    containerPadding: '5px',
    addedBackgroundColor: 'rgb(237, 252, 219)',
    activeBorder: '3px solid rgb(95,143,192)',
  },
  zoomControls: {
    color: '#8d8d8d',
    backgroundColor: '#8f8f8f',
    buttonColor: '#8d8d8d',
    buttonDisabledColor: '#bfbfbf',
    sliderHoverShadow: '0px 0px 0px 8px rgb(0 0 0 / 10%);',
    sliderActiveShadow: '0px 0px 0px 14px rgb(0 0 0 / 16%);',
  },
  viewControls: {
    color: '#bfbfbf',
    activeColor: '#636363',
  },
  landingPage: {
    headerColor: '#353535',
    textColor: '#636363',
    pageBox: {
      backgroundColor: '#fff',
      maxWidth: '1080px',
    },
  },
  // next gen
  avatar: {
    backgroundColor: '#F1F2F4',
    textColor: '#181A30',
  },
};

// NOTE: update on the go...
// default theme should be replaced by light theme when we will be done with legacy components...
const coleyTheme = {
  ...defaultTheme,
  fontFamily: {
    main: 'Effra, sans-serif',
    // main: 'Monaco, monospace',
    code: 'Monaco, monospace',
  },
  fontSize: {
    h1: '2.57rem',
    h2: '2rem',
    h3: '18px',
    h5: '0.92rem',
    larger: '1.2rem',
    default: '1rem',
    smaller: '0.93rem',
  },
  spacing: {
    small: '0.5rem',
    default: '0.8rem',
    medium: '1.25rem',
    large: '1.9rem',
    xLarge: '3rem',
  },
  radius: {
    xSmall: '0.30rem',
    small: '0.57rem',
    normal: '1rem',
    default: '1rem',
    large: '1.9rem',
    xLarge: '3rem',
  },
  size: {
    medium: '2.5rem',
    large: '104px', // @todo
    small: '24px', // @todo
  },
};

const darkTheme = {
  ...coleyTheme,
  palette: {
    ...coleyTheme.palette,
    white: '#323C47',
    gray: '#b5b9d7',
    text: '#d9d9d9',
    background: '#363b3d',
    placeholderText: '#a5a7bd',
    iconStroke: '#9799a8',
  },
};

export const themes = {
  default: defaultTheme,
  dark: darkTheme,
  coley: coleyTheme,
};
